<app-heading [title]="'People'" [showToggle]="false" [button]="headingButton" [extraButton]="!userObject.firm.reviewerAutoApproval && pendingCandidateButton" [extraButton2]="userObject.firm.reviewerAutoApproval && userObject.firm.expiredCredentialApproval && expiredCredentialsCandidateButton"></app-heading>
<div class="projects-data all-people-container">
    <div class="grid grid-nogutter">
        <div class="col-12 p-0">
            <div class="grid grid-nogutter">
                <div class="col-12 md:col-6 xl:col-6 lg:col-6 sm:col-12 p-0">
                    <div class="wrap-left">
                       <div class="grid grid-nogutter">
                            <div class="md:pr-1 sm:pr-0 col-12 md:col-4 sm:col-12 ">
                                <p-iconField iconPosition="right">
                                    <p-inputIcon (click)="onSearchClick()"  styleClass="pi pi-search" />
                                    <input [(ngModel)]="searchText" (keydown)="onEnter($event)" type="text" pInputText placeholder="Search" />
                                </p-iconField>
                            </div>
                            <div class="my-2 md:my-0 md:pl-2 sm:pl-0 col-12 md:col-4 sm:col-12">
                                <p-dropdown  [(ngModel)]="selectedSortOrder"  (onChange)="onSortChange($event)" [options]="sortings" optionLabel="name"
                                [placeholder]="'Sort By' | sentenceCase" />
                                
                            </div>
                            <div class="my-2 md:my-0 md:pl-2 sm:pl-0 col-12 md:col-4 sm:col-12">
                                <p-dropdown [(ngModel)]="selectedUserFilter"  (onChange)="onFilterChange($event)" [options]="userFilters" optionLabel="name"
                                placeholder="Filter" />
                            </div>
                            <div class="p-0 col-12 md:col-12 sm:col-12">
                                <ul class="chips">
                                    @if(displaySearchTextChip){
                                        <li><p-chip [label]="searchTextDisplaying" (onRemove)="onRemoveChip('searchText')" [removable]="true" /></li>
                                    }
                                    @if(selectedSortOrder && selectedSortOrder.name){
                                        <li><p-chip [label]="selectedSortOrder.name" (onRemove)="onRemoveChip('sortOrder')" [removable]="true" /></li>
                                    }
                                    @if(selectedUserFilter && selectedUserFilter.name){
                                        <li><p-chip [label]="selectedUserFilter.name" (onRemove)="onRemoveChip('userFilter')" [removable]="true" /></li>
                                    }
                                    </ul>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0">
            <div class="data-table">
                <p-table styleClass="p-datatable-sm p-datatable-sm--normal"
                #reviewerTable
                [value]="reviewers" 
                [lazy]="true"
                [rows]="10"
                [paginator]="true"
                [totalRecords]="reviewerCount"
                (onLazyLoad)="getReviewers($event)"
                [showCurrentPageReport]="true" 
                [paginator]="true" 
                [tableStyle]="{ 'min-width': '50rem' }"
                currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
                autoLayout="true"
                (onPage)="onPageChange($event)"
                [scrollable]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width:15%">
                                Name
                            </th>
                            <th style="width:15%">
                                Email
                            </th>
                            <th style="width:15%">
                                Rating
                            </th>                       
                            <th style="width:10%">
                                Status
                            </th>
                            @if (helperService.checkResponsive()) {
                                <th alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                                } @else {
                                <th style="width:20%">
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                                }
                                <ng-template #frozenHeader>
                                Action
                                </ng-template>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-reviewer>
                        <tr>
                            <td><span class="cursor-pointer" (click)="openReviewerDialog(reviewer._id)">
                                {{reviewer.fullName}}
                            </span></td>
                            <td><span class="cursor-pointer" (click)="openReviewerDialog(reviewer._id)">{{reviewer.email}}</span></td>
                            <td>
                                <p-rating [(ngModel)]="reviewer.defaultTenantRating" [readonly]="true" [cancel]="false" class="cursor-default"/>
                            </td>
                            <td>
                                @if(selectedUserFilter.value === 'invited'){
                                    <p-tag value="Invited" [rounded]="true" class="incompleteStatus" />
                                } @else if(selectedUserFilter.value === 'archive'){
                                    @if(isArchivedByReviewer(reviewer)){
                                        <p-tag value="Opted Out" [rounded]="true" class="incompleteStatus" />
                                    } @else {
                                        <p-tag value="Archived" [rounded]="true" class="archived" />
                                    }
                                } @else {
                                    @if(isAdminApprovalPending(reviewer)){
                                        <p-tag value="Pending" [rounded]="true" class="pendingStatus" />
                                    } @else {
                                        @if(reviewer.status) {
                                            <p-tag value="Active" [rounded]="true" class="activeStatus" />
                                        } @else {
                                            <p-tag value="Inactive" [rounded]="true" class="pillInactive cursor-pointer" (click)="activateUser($event, reviewer)"/>
                                        }
                                    }
                                }
                            </td>
                            @if (helperService.checkResponsive()) {
                                <td alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                                } @else {
                                <td>
                                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                                } 
                                <ng-template #frozenData>
                                    <div class="wrap-actions">
        
                                        @if(!isAdminApprovalPending(reviewer)){
                                            @if(selectedUserFilter && selectedUserFilter.value !== 'archive' && selectedUserFilter.value !== 'invited') {

                                                <p-button class="action-icon" [pTooltip]="(reviewer.workedTogether? 'Remove from Worked Together List': 'Add to Worked Together List') | sentenceCase" tooltipPosition="top" (click)="moveToWorkedTogetherList($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                                                    <span [class.freshgreen]="reviewer.workedTogether" [class.light-grey]="!reviewer.workedTogether" class="{{helperService.getEnvironmentName()}}-icon icon-group-outlined"></span>
                                                </p-button>
                                                <p-button class="action-icon" [pTooltip]="reviewer.isFavourite? 'Remove from favorite': 'Add to favorite'" tooltipPosition="top" (click)="favouriteUser($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                                                    <span [class.vibrant-pink]="reviewer.isFavourite" [class.light-grey]="!reviewer.isFavourite" class="{{helperService.getEnvironmentName()}}-icon icon-bookmark-star-outlined"></span>
                                                </p-button>
                                                <p-button class="action-icon" [pTooltip]="(reviewer.isRestricted? 'Remove Candidate from Restricted List': 'Add Candidate to Restricted List') | sentenceCase" tooltipPosition="top" (click)="moveToRestrictedList($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                                                    <span [class.red]="!reviewer.isRestricted" [class.bright-red]="reviewer.isRestricted" class="{{helperService.getEnvironmentName()}}-icon icon-block-outlined"></span>
                                                </p-button>
                                                @if(reviewer.projectId && reviewer.positionId){
                                                    <p-button class="action-icon" pTooltip="Fire Candidate" tooltipPosition="top" (click)="fireAndQuit($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-account-circle-off-outlined"></span>
                                                    </p-button>
                                                }
                                            }
                                            @if(selectedUserFilter && selectedUserFilter.value === 'invited'){
                                                <p-button class="action-icon" pTooltip="Resend Invite" [disabled]="reviewer.cannotReInvite"  (click)="resendInvite($event,reviewer)" tooltipPosition="top"  [rounded]="true" [text]="true" icon="true">
                                                    <span class="{{helperService.getEnvironmentName()}}-icon icon-redo-outlined"></span>
                                                </p-button>
                                            }
                                            @if(selectedUserFilter && selectedUserFilter.value === 'archive'){
                                                @if(isArchivedByReviewer(reviewer)){
                                                    <div style="width: fit-content;" [pTooltip]="'Candidate Initiated Archival'" tooltipPosition="top">
                                                    <p-button class="action-icon" [disabled]="true" tooltipPosition="top"  [rounded]="true" [text]="true" icon="true">
                                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-sync-outlined"></span>
                                                    </p-button>
                                                     </div>
                                                }@else{
                                                    <p-button class="action-icon" [pTooltip]="'Reactivate'" tooltipPosition="top" (click)="showDeleteReviewerConfirmation($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-sync-outlined"></span>
                                                    </p-button>
        
                                                }
                                                
                                            } @else if(selectedUserFilter && selectedUserFilter.value !== 'invited'){
                                                <p-button [pTooltip]="'Archive'" tooltipPosition="top" (click)="showDeleteReviewerConfirmation($event,reviewer)" [rounded]="true" [text]="true" icon="true">
                                                    <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined bright-red"></span>
                                                </p-button>
                                            }
                                        }
                                        
                                    </div>
                                </ng-template>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>

<p-dialog [modal]="true" draggable="false" [(visible)]="openUnarchiveModal"
    [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }" [style]="{ width: '800px' }">

    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">
                Confirmation
            </span>
        </div>
    </ng-template>

    <ng-template pTemplate="body">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="white-space-nowrap">
                Are you sure you want to unarchive {{selectedReviewer?.firstName}} {{selectedReviewer?.lastName}}?
            </span>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="no" size="large" [rounded]="true" (onClick)="confirmUnarchiveUser()" />
        <p-button label="yes" size="large" [rounded]="true" (onClick)="confirmUnarchiveUser(true)" />
    </ng-template>
</p-dialog>
